import React from "react";
import { Input } from "@/components/ui/input";
import { RadixSelect } from "@/components/ui/select";
import { LayerLabelSettings } from "@/types/diagram";
import { Label } from "@/components/ui/label";

export const WEB_SAFE_FONTS = [
    { value: "Arial", label: "Arial" },
    { value: "Helvetica", label: "Helvetica" },
    { value: "Times New Roman", label: "Times New Roman" },
    { value: "Times", label: "Times" },
    { value: "Courier New", label: "Courier New" },
    { value: "Courier", label: "Courier" },
    { value: "Verdana", label: "Verdana" },
    { value: "Georgia", label: "Georgia" },
    { value: "Palatino", label: "Palatino" },
    { value: "Garamond", label: "Garamond" },
    { value: "Bookman", label: "Bookman" },
    { value: "Comic Sans MS", label: "Comic Sans MS" },
    { value: "Trebuchet MS", label: "Trebuchet MS" },
    { value: "Arial Black", label: "Arial Black" },
    { value: "sans-serif", label: "Sans-serif" }
];

interface LayerSettingsTabProps {
    settings: LayerLabelSettings;
    onChange: (
        key: keyof LayerLabelSettings,
        value: number | string | boolean
    ) => void;
}

export const LayerSettingsTab: React.FC<LayerSettingsTabProps> = ({
    settings,
    onChange
}) => {
    return (
        <div className="space-y-4">
            <div>
                <Label className="block text-sm font-medium text-white mb-1">
                    Width
                </Label>
                <Input
                    type="number"
                    value={settings.width}
                    onChange={(e) =>
                        onChange("width", parseInt(e.target.value))
                    }
                    min={1}
                    className="bg-surface-input border-surface-border text-white"
                />
            </div>
            <div>
                <Label className="block text-sm font-medium text-white mb-1">
                    Line Spacing
                </Label>
                <Input
                    type="number"
                    value={settings.lineSpacing}
                    onChange={(e) =>
                        onChange("lineSpacing", parseFloat(e.target.value))
                    }
                    step="0.1"
                    min="1"
                    className="bg-surface-input border-surface-border text-white"
                />
            </div>
            <div>
                <Label className="block text-sm font-medium text-white mb-1">
                    Font Family
                </Label>
                <RadixSelect
                    options={WEB_SAFE_FONTS}
                    value={settings.fontFamily}
                    onChange={(value) => onChange("fontFamily", value)}
                    placeholder="Select font"
                />
            </div>
            <div>
                <Label className="block text-sm font-medium text-white mb-1">
                    Font Size
                </Label>
                <Input
                    type="number"
                    value={settings.fontSize}
                    onChange={(e) =>
                        onChange("fontSize", parseInt(e.target.value))
                    }
                    min={1}
                    className="bg-surface-input border-surface-border text-white"
                />
            </div>
            <div>
                <Label className="block text-sm font-medium text-white mb-1">
                    Font Weight
                </Label>
                <RadixSelect
                    options={[
                        { value: "normal", label: "Normal" },
                        { value: "bold", label: "Bold" }
                    ]}
                    value={settings.fontWeight}
                    onChange={(value) => onChange("fontWeight", value)}
                    placeholder="Select weight"
                />
            </div>
            <div className="flex items-center space-x-2">
                <input
                    type="checkbox"
                    id="hide-labels"
                    checked={settings.hideLabels}
                    onChange={(e) => onChange("hideLabels", e.target.checked)}
                    className="rounded border-surface-border bg-surface-input text-primary focus:ring-primary"
                />
                <Label htmlFor="hide-labels" className="text-sm text-white">
                    Hide Labels
                </Label>
            </div>
        </div>
    );
};